import { z } from 'zod';

export enum SubscriptionType {
    Dynamic = 'dynamic',
    Static = 'static',
}

export const SubscriptionTypeSchema = z.nativeEnum(SubscriptionType);